module.exports = __webpack_public_path__ + "img/syukyaku-co-back001.eaa362b5.jpg";